import React from "react";
import UserListe from "./UserListe";
import Überschrift from "./überschrift";



class Dasboart extends React.Component {
    render() {
        return(
            <React.Fragment>
                <div className="arrounddasbord">
                    <div className="logo" style={{fontSize:"3rem", paddingLeft:"1rem", fontFamily:"Academy Engraved LET", display:"block",position:"fixed"}}></div>
            <Überschrift />
                <div className="listrows">
                    <UserListe name="Rasmus" />
                    <UserListe name="Silas" />
                    <UserListe name="Jokim" />
                </div>
                <div className="listrows">
                    <UserListe name="Talika" />
                    <UserListe name="Janika" />
                    <UserListe name="Kiara" />
                </div>
                <div className="listrows">
                    <UserListe name="Katja" />
                    <UserListe name="Caroline" />
                    <UserListe name="Stefan" />
                </div>
                <div className="listrows">
                    <UserListe name="Culbin" />
                    <UserListe name="Max" />
                    <UserListe name="Lena" />
                        
                </div>
                </div>

            </React.Fragment>
            
        )
    }
}

export default Dasboart